import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import FeaturedSection from './components/FeaturedSection';
import CategorySection from './components/CategorySection';
import LatestSection from './components/LatestSection';
import TestimonialSection from './components/TestimonialSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  useEffect(() => {
    document.title = '火影忍者雏田本子 - 精选同人创作合集';
  }, []);

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '雏田同人馆',
    url: 'https://hinata-doujin.readdy.ai',
    description: '探索火影忍者雏田本子的精选同人创作内容，汇聚海量雏田相关同人漫画、插画与二次创作作品。',
    inLanguage: 'zh-CN',
  };

  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '雏田同人馆',
    url: 'https://hinata-doujin.readdy.ai',
    description: '专注火影忍者雏田角色同人创作的内容聚合平台',
  };

  const webpageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '火影忍者雏田本子 - 精选同人创作合集',
    description: '探索火影忍者雏田本子的精选同人创作内容，汇聚海量雏田相关同人漫画、插画与二次创作作品，为火影忍者粉丝提供最全面的雏田本子资源导览与推荐。',
    url: 'https://hinata-doujin.readdy.ai',
    isPartOf: {
      '@type': 'WebSite',
      name: '雏田同人馆',
      url: 'https://hinata-doujin.readdy.ai',
    },
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '什么是雏田本子？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '雏田本子是指以火影忍者中的日向雏田角色为主题的同人志（Doujinshi），包括同人漫画、插画集、短篇小说等二次创作作品。',
        },
      },
      {
        '@type': 'Question',
        name: '如何浏览和查找特定类型的雏田同人作品？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '您可以通过网站顶部的分类导航浏览不同类型的作品，包括同人漫画、插画作品、短篇同人、同人小说、Cosplay摄影和动画剪辑六大类别。',
        },
      },
      {
        '@type': 'Question',
        name: '网站上的同人作品是否可以下载？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '本站作为同人作品的导览和推荐平台，提供作品的详细信息、预览图和推荐链接。具体的下载或购买方式请参考每篇作品的详细信息页面。',
        },
      },
      {
        '@type': 'Question',
        name: '如何投稿自己的雏田同人作品？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '我们非常欢迎同人创作者的投稿！您可以通过关于我们页面中的联系方式与我们取得联系，提交您的作品信息和预览图。',
        },
      },
      {
        '@type': 'Question',
        name: '网站内容是否定期更新？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '是的，我们的编辑团队每周都会更新新的雏田同人作品推荐。您可以关注网站的"最新更新"板块获取更新通知。',
        },
      },
    ],
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(organizationSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(webpageSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>

      <div className="min-h-screen flex flex-col">
        <Navbar transparent />
        <main>
          <Hero />
          <FeaturedSection />
          <CategorySection />
          <LatestSection />
          <TestimonialSection />
          <FAQSection />
          <CTASection />
        </main>
        <Footer />
      </div>
    </>
  );
}